module.exports = __webpack_public_path__ + "static/logo-592e9d82850e4f8efc16021bcc9b9f7c.png";